module.exports = __webpack_public_path__ + "static/media/NX-logo-background@2x.fb2bf99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NX-logo-background@2x.png
// module id = 627
// module chunks = 0